import { AfterViewInit, ComponentFactoryResolver, ComponentRef, Directive, HostListener, Injector, Input, Optional, TemplateRef, ViewContainerRef } from "@angular/core";
import { AvanoPopoverComponent } from "./avano-popover.component";

export interface PopoverStateChange {
  enabled: boolean;
  visible: boolean;
}
/**
 * Additionally to implementing as interface, the component needs to provide itself to the injection tree. Only then can AvanoPopover use the callback.
 * @example
 * providers: [
    {
      provide: AvanoPopoverSupport,
      useExisting: forwardRef(() => MyComponentImplementingThatInterface)
    }
  ]
 */
export abstract class AvanoPopoverSupport {
  popoverStateChanged: (newState: PopoverStateChange) => void;
}

@Directive({
  selector: '[avanoPopover]'
})
export class AvanoPopoverDirective implements AfterViewInit {
  @Input() avanoPopover: TemplateRef<any>;

  popoverComponent: ComponentRef<AvanoPopoverComponent>;
  get popoverComponentInstance(): AvanoPopoverComponent {
    return this.popoverComponent?.instance;
  }

  constructor(
    @Optional() protected popoverSupport: AvanoPopoverSupport,
    protected viewContainerRef: ViewContainerRef,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected injector: Injector
  ) {}
  ngAfterViewInit(): void {
    const popoverFactory = this.componentFactoryResolver.resolveComponentFactory(AvanoPopoverComponent);
    this.popoverComponent = this.viewContainerRef.createComponent(popoverFactory);
    this.popoverComponent.changeDetectorRef.detectChanges();

    this.popoverComponentInstance.contentTemplate = this.avanoPopover;
    if (this.popoverSupport) {
      this.popoverSupport.popoverStateChanged({ enabled: true, visible: false });
    }
  }
  @HostListener('click', ['$event'])
  onClick(evt: PointerEvent) {
    this.popoverComponentInstance?.toggle(evt);
    this.popoverComponent.changeDetectorRef.markForCheck();
    if (this.popoverSupport) {
      const isVisible = this.popoverComponentInstance?.render === true;
      this.popoverSupport.popoverStateChanged({ enabled: true, visible: isVisible });
    }
  }
}
